import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { NewButton, NewButtonVariant } from '../../../../../components/synced/ui';

interface ConfirmButtonProps {
    label?: string;
    tooltip?: string;
    variant?: NewButtonVariant;
    icon?: string;
    message: string;
    header?: string;
    disabled?: boolean;
    action: () => void;
    rejectLabel?: string;
    acceptLabel?: string;
    acceptVariant?: NewButtonVariant;
    acceptIcon?: string;
    children?: React.ReactNode;
}

export const ConfirmButton: React.FC<ConfirmButtonProps> = ({
    label,
    tooltip,
    variant = 'danger',
    icon,
    message,
    header = 'Подтверждение',
    disabled,
    action,
    rejectLabel = 'Отмена',
    acceptLabel = 'Да',
    acceptVariant = 'danger',
    acceptIcon,
    children
}) => {
    const [visible, setVisible] = React.useState(false);

    return (
        <>
            <NewButton
                variant={variant}
                icon={icon}
                disabled={disabled}
                tooltip={tooltip}
                onClick={() => setVisible(true)}
            >
                {label}
                {children}
            </NewButton>

            <Dialog
                header={header}
                visible={visible}
                className="pd-dialog"
                style={{ width: '400px' }}
                onHide={() => setVisible(false)}
                footer={
                    <div className="pd-dialog-footer">
                        <NewButton variant="secondary" icon="fa-solid fa-xmark" onClick={() => setVisible(false)}>
                            {rejectLabel}
                        </NewButton>
                        <NewButton
                            variant={acceptVariant}
                            icon={acceptIcon}
                            onClick={() => {
                                setVisible(false);
                                action();
                            }}
                        >
                            {acceptLabel}
                        </NewButton>
                    </div>
                }
            >
                <div className="pd-dialog-body">
                    <span>{message}</span>
                </div>
            </Dialog>
        </>
    );
};
